import {createEntityAdapter, createSlice} from "@reduxjs/toolkit";
import {codeObject, datasourceTypeObject, stationObject, stnEntity} from "../../Constructor/common/constructorObject";

export const sensorDeviationObject = {
    station: {},
    checkedDatasourceType: {},
    checkedStationEntity: {},
    idealDatasourceType: {},
    idealStationEntity: {},
    code: {}
}

export const SENSOR_DEVIATION_SLICE = 'sensorDeviation';

const sensorDeviationAdapter = createEntityAdapter();
const sensorDeviationSlice = createSlice({
    name: SENSOR_DEVIATION_SLICE,
    initialState: sensorDeviationAdapter.getInitialState({...sensorDeviationObject}),
    reducers: {
        selectStationForSensorDeviation: (state, action) => {
            Object.assign(state.station, action.payload)
        },
        selectCheckedDatasourceTypeForSensorDeviation: (state, action) => {
            Object.assign(state.checkedDatasourceType, action.payload)
        },
        selectIdealDatasourceTypeForSensorDeviation: (state, action) => {
            Object.assign(state.idealDatasourceType, action.payload)
        },
        selectCheckedStationEntityForSensorDeviation: (state, action) => {
            Object.assign(state.checkedStationEntity, action.payload)
        },
        selectIdealStationEntityForSensorDeviation: (state, action) => {
            Object.assign(state.idealStationEntity, action.payload)
        },
        selectCodeForSensorDeviation: (state, action) => {
            Object.assign(state.code, action.payload)
        },

        clearState: (state) => {
            state.station = {...stationObject}
            state.checkedDatasourceType = {...datasourceTypeObject}
            state.idealDatasourceType = {...datasourceTypeObject}
            state.checkedStationEntity = {...stnEntity}
            state.idealStationEntity = {...stnEntity}
            state.code = {...codeObject}
        }
    },
    extraReducers: {},
});

export default sensorDeviationSlice.reducer;

export const {
    selectStationForSensorDeviation,
    selectCheckedDatasourceTypeForSensorDeviation,
    selectIdealDatasourceTypeForSensorDeviation,
    selectCheckedStationEntityForSensorDeviation,
    selectIdealStationEntityForSensorDeviation,
    selectCodeForSensorDeviation,
    clearState
} = sensorDeviationSlice.actions;